/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React, { useState, useContext } from 'react';
import { CloseCircleOutlined, CheckCircleOutlined, DollarCircleOutlined } from '@ant-design/icons';
import { Input, Col, Row, message, Divider, Popover } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';
import { CodContext } from 'views/CashOnDelivery/Routes/CashOnDeliveryByParcel/common/context/CodContext';
import UPDATE_COD_PARCEL_MUTATION, {
  UpdateCodParcelData,
  UpdateCodParcelVars,
} from 'shared/graphql/mutation/updateCodParcel';
import formatCurrency from 'shared/utils/formatCurrency';
import { Button, Text } from 'shared/components';
import { formatDateTime } from 'shared/utils/dateTime';
import { StyledModal } from './Styles';
import CardIcon from '../CardIcon';

const { TextArea } = Input;

type ModalConfirmRejectProps = {
  visible: boolean;
  onCancel: () => void;
  goBack: string;
};

const ModalConfirmReject: React.FC<ModalConfirmRejectProps> = (props) => {
  const { onCancel, visible, goBack } = props;
  const [rejectRemark, setRejectRemark] = useState<string>('');
  const { selectedCodDetail } = useContext(CodContext);
  const { codId, modalConfirm } = selectedCodDetail;
  const { totalCod, vendorFullName, shipmentNumbers, codInDate } = modalConfirm;
  const history = useHistory();

  const closeModalHandler = () => {
    history.push(goBack);
  };

  const [updateCod, { loading }] = useMutation<UpdateCodParcelData, UpdateCodParcelVars>(
    UPDATE_COD_PARCEL_MUTATION,
    {
      update: (_cache, { data }) => {
        if (data?.updateCodParcel._id) {
          message.success('ปฏิเสธรายการยอด COD แล้ว');
          onCancel();
          closeModalHandler();
        }
      },
      onError: (err) => {
        message.error(err.message);
      },
      refetchQueries: () => ['CodParcel', 'CodParcelStatus', 'CodParcels', 'CodParcelOrderStatus'],
    },
  );

  const confirmReject = () => {
    updateCod({
      variables: {
        _id: codId,
        cod_status: 4,
        reject_remark: rejectRemark,
      },
    });
  };

  const contentPopOverShipmentNumber = (value: string[]) => {
    return (
      <>
        <Row>
          <Col>
            <Text>Shipment No: </Text>
          </Col>
        </Row>
        {value.map((item) => (
          <Row key={uuidv4()}>
            <Col>
              <Text strong>{item}</Text>
            </Col>
          </Row>
        ))}
      </>
    );
  };

  const popOverShipmentNumber = (value: string[]) => {
    if (value.length === 1) {
      return <Text>{value[0]}</Text>;
    }
    if (value.length > 1) {
      return (
        <Popover placement="rightTop" content={contentPopOverShipmentNumber(value)}>
          <div style={{ display: 'inline' }}>
            <Text>{value.length} รหัส</Text>
          </div>
        </Popover>
      );
    }
    return '-';
  };

  return (
    <StyledModal
      className="custom-modal"
      title="ต้องการปฎิเสธรายการยอดCOD ใช่หรือไม่?"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="okButton"
          icon={<CheckCircleOutlined />}
          color="red--light"
          onClick={() => confirmReject()}
          loading={loading}
          disabled={rejectRemark === ''}
        >
          ใช่, ต้องการปฎิเสธ
        </Button>,
        <Button
          key="cancelButton"
          icon={<CloseCircleOutlined />}
          onClick={onCancel}
          disabled={loading}
        >
          ยกเลิก
        </Button>,
      ]}
      afterClose={() => setRejectRemark('')}
    >
      <Row gutter={[32, 16]}>
        <Col
          span={12}
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <CardIcon
            title="จำนวนที่ 3PL ต้องโอน (บาท)"
            text={<Text customType="primary">{`${formatCurrency(totalCod)} บาท`}</Text>}
            icon={<DollarCircleOutlined />}
          />
        </Col>
      </Row>

      <Divider style={{ marginBottom: 10, marginTop: -5 }} />

      <Row>
        <Col span={12}>
          <Row>
            <Col span={8}>ชื่อ 3PL:</Col>
            <Col span={16}>
              <Text strong>{vendorFullName || '-'}</Text>
            </Col>
          </Row>
          <Row>
            <Col span={8}>Shipment No.:</Col>
            <Col span={16}>
              <Text strong>{popOverShipmentNumber(shipmentNumbers)}</Text>
            </Col>
          </Row>
          <Row>
            <Col span={8}>วันที่แจ้งโอน:</Col>
            <Col span={16}>
              <Text strong>{codInDate ? formatDateTime(codInDate) : '-'}</Text>
            </Col>
          </Row>
        </Col>
      </Row>

      <Divider style={{ marginBottom: 0, marginTop: 10 }} />

      <Row>
        <Col span={24}>
          เหตุผลการปฎิเสธ:<Text type="danger">*</Text>
        </Col>
        <Col span={24}>
          <TextArea
            value={rejectRemark}
            onChange={(event) => setRejectRemark(event.target.value)}
            placeholder="ระบุ"
            rows={2}
          />
        </Col>
      </Row>
    </StyledModal>
  );
};

export default ModalConfirmReject;
